import { render, staticRenderFns } from "./alertTransfer.vue?vue&type=template&id=0d721218&"
import script from "./alertTransfer.vue?vue&type=script&lang=js&"
export * from "./alertTransfer.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/fontFace.css?vue&type=style&index=0&lang=css&"
import style1 from "./alertTransfer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports